export default "__VITE_ASSET__Bpk$AsMr__";